module.exports = __webpack_public_path__ + "img/IMG_9464.af29227b.jpg";